export const dateWithTimeZone = (
  timeZone: string,
  year: number,
  month: number, // function to convert local time to particular timezone
  day: number,
  hour: number,
  minute: number,
  second: number
): Date => {
  const date = new Date(Date.UTC(year, month, day, hour, minute, second));
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Vienna' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone: timeZone }));
  const offset = utcDate.getTime() - tzDate.getTime();
  date.setTime(date.getTime() + offset);
  return date;
};

export const calculateDateTime = (dateObj: Date): Date => {
  let time = new Date(dateObj);
  time = dateWithTimeZone(
    'Europe/Vienna', //this sets timezone to +1 / +2 automatically depending on daylight savings
    time.getFullYear(), //convert local time to UTC
    time.getMonth(),
    time.getDate(),
    time.getHours(),
    time.getMinutes(),
    time.getSeconds()
  );
  return time;
};

/* if the offer/slide is expired and the customer is on the same page when it happens, then the button will be hidden */
let startTime: number | Date, endTime: number | Date, timeInRange: any;
export const CheckTime = (content: any, timer: any, setIsTimerActive: any) => {
  if (timer.startTime) {
    startTime = calculateDateTime(new Date(timer.startTime.replace(/-/g, '/')));
  }
  if (timer.endTime) {
    endTime = calculateDateTime(new Date(timer.endTime.replace(/-/g, '/')));
  }
  if (startTime && startTime <= new Date() && endTime && endTime > new Date()) {
    timeInRange = true;
  } else timeInRange = false;
  if (
    (startTime && endTime && timeInRange) ||
    content.startTimeContent === '' ||
    content.endTimeContent === '' ||
    content.enableCounter == false
  ) {
    setIsTimerActive(true);
  } else {
    setIsTimerActive(false);
  }
};

export const getCookies = (cname: string): any => {
  const name = cname + '=';
  const cookies = document.cookie.split(';');
  let cookieData: any;
  cookies.some((cookie) => {
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      cookieData = JSON.parse(decodeURIComponent(cookie.substring(name.length, cookie.length)));
      return true;
    }
    return false;
  });
  return cookieData;
};
